import { useAxios } from '@/hooks/useAxios';
import { getQueryKey } from '@/hooks/useQueryKeys';
import { GraphQuery, GraphQueryResponse, TreeNode } from '@/types';
import { useQuery } from '@/utils/api';

interface UseGraphQueryProps {
  query: GraphQuery;
  tree?: boolean;
  enabled?: boolean;
}

export const useGraphQuery = <T extends boolean = false>({
  query,
  tree = false as T,
  enabled = true,
}: UseGraphQueryProps & { tree?: T }) => {
  const axios = useAxios();

  return useQuery<T extends true ? TreeNode[] : GraphQueryResponse>({
    enabled,
    queryKey: getQueryKey.getGraphQuery(query),
    queryFn: async () => {
      const { data } = await axios({
        method: 'POST',
        url: '/my',
        params: { tree },
        data: query,
      });
      return data;
    },
    defaultErrorMessage: 'An error occurred while fetching data.',
  });
};
